import { render } from "./ProductGroupList.vue?vue&type=template&id=02137c0e&scoped=true"
import script from "./ProductGroupList.vue?vue&type=script&lang=js"
export * from "./ProductGroupList.vue?vue&type=script&lang=js"

import "./ProductGroupList.vue?vue&type=style&index=0&id=02137c0e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02137c0e"]])

export default __exports__